import { PersonFunctionViewModel } from '@app/Models';
import { RangeHelper } from '@app/Helpers/RangeHelper';
import { PersonFunctions } from '@app/AppConstants';

export function isCabinAt(personFunctions: PersonFunctionViewModel[], date: Date) {
    const currentFunction = RangeHelper.findSelectedFunctionRange(personFunctions, date);
    if (!currentFunction) {
        return false;
    }
    const { functionName } = currentFunction;
    return functionName === PersonFunctions.SC || functionName === PersonFunctions.CC;
}

export function isCockpitAt(personFunctions: PersonFunctionViewModel[], date: Date) {
    const currentFunction = RangeHelper.findSelectedFunctionRange(personFunctions, date);
    if (!currentFunction) {
        return false;
    }
    const { functionName } = currentFunction;
    return functionName === PersonFunctions.PIC || functionName === PersonFunctions.FO;
}
